import { render, staticRenderFns } from "./oauth-login.vue?vue&type=template&id=250fa004"
import script from "./oauth-login.vue?vue&type=script&lang=js"
export * from "./oauth-login.vue?vue&type=script&lang=js"
import style0 from "./oauth-login.vue?vue&type=style&index=0&id=250fa004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports